<template>
  <Loader2Icon :class="cn('h-5 w-5 animate-spin', $attrs.class ?? '')" />
</template>

<script setup lang="ts">
import { Loader2Icon } from '@lucide/vue';

import { cn } from '@/shared/lib/misc';
</script>
